import { ElementRef, Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FieldHighlightRefService {
  private readonly _elementRef = signal<ElementRef<HTMLElement> | undefined>(undefined);

  readonly elementRef = this._elementRef.asReadonly();

  setElementRef(elementRef: ElementRef<HTMLElement> | undefined) {
    this._elementRef.set(elementRef);
  }
}
